import { queryClient } from '@/client/query';
import interventions from '@/repositories/interventions.repository';
import { useMutation, useQuery } from '@tanstack/react-query';

export function useInterventions() {
  return useQuery({
    queryKey: ['interventions', 'get'],
    queryFn: interventions.get,
  });
}

export function useCompleteInterventionMutation() {
  return useMutation({
    mutationFn: interventions.post,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['interventions', 'get'] });
    },
  });
}
